import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LoadingOutlined,
  MinusOutlined,
} from '@ant-design/icons'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { AccessLevelControlProps, IconComponent } from '../../utils/types'
import styles from './index.module.css'

const EyeIcon = EyeInvisibleOutlined as unknown as IconComponent
const OpenEyeIcon = EyeOutlined as unknown as IconComponent
const LoaderIcon = LoadingOutlined as unknown as IconComponent
const MixedIcon = MinusOutlined as unknown as IconComponent

const AccessLevelControl = ({
  state,
  disabled = false,
  loading = false,
  tooltip,
  ariaLabel,
  onClick,
}: AccessLevelControlProps) => (
  <TooltipWrapper title={tooltip} placement="top">
    <span className={styles.tooltipTarget}>
      <button
        type="button"
        role="switch"
        aria-label={ariaLabel}
        aria-checked={state === 'mixed' ? 'mixed' : state === 'on'}
        className={cn(
          styles.button,
          state === 'on' && styles.active,
          state === 'mixed' && styles.mixed,
        )}
        disabled={disabled || loading}
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          onClick()
        }}
      >
        {loading ? (
          <LoaderIcon spin />
        ) : state === 'on' ? (
          <OpenEyeIcon />
        ) : (
          <EyeIcon />
        )}
        {state === 'mixed' && !loading && (
          <MixedIcon className={styles.mixedMark} />
        )}
      </button>
    </span>
  </TooltipWrapper>
)

export default AccessLevelControl
